import type { TableColumn, TableData, TopColumnsType } from '../Table';

/**
 * Calculates and returns the final columns for header and body
 * based on the current layout (desktop or mobile)
 */
export const calculateColumns = <Data extends TableData>(
  columns: TableColumn<Data>[],
  isMobileLayout: boolean,
  topColumns?: TopColumnsType<Data>,
) => {
  const visibleColumns = columns.filter((column) => !column.hidden);

  const columnCount = visibleColumns.length;

  const finalTopColumns = topColumns ?? (columnCount > 0 ? [visibleColumns[0].name] : []);

  const headerColumns = isMobileLayout
    ? visibleColumns.filter((col) => finalTopColumns.includes(col.name))
    : visibleColumns;

  return {
    headerColumns,
    bodyColumns: visibleColumns,
    columnCount,
    finalTopColumns,
  };
};
